angular.module('zc.zenclerkS')
  .factory('FeatureNotification', FeatureNotification);

FeatureNotification.$inject = ['Api'];
function FeatureNotification(Api) {
  const service = {
    markAsRead,
    markAsShown,
    resetAll
  };

  return service;

  function markAsShown(notification) {
    return Api.post('/api/feature_notifications/mark_as_shown', { key: notification.key });
  }

  function markAsRead(notification) {
    return Api.post('/api/feature_notifications/mark_as_read', {key: notification.key});
  }

  // for development & testing purposes, allow resetting notifications
  function resetAll() {
    return Api.post('/api/feature_notifications/reset_all');
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/feature_notification.service.js